module.exports = __webpack_public_path__ + "img/small_back_arrow.160ffbbb.svg";